export default __webpack_public_path__ + "static/media/bloodforaid5.43e4bce2.png";